/**
 * Map Controls Component
 *
 * Renders map control buttons (zoom, location)
 * following Single Responsibility Principle
 */

import React from 'react';
import {ZoomIn, ZoomOut, Navigation} from 'lucide-react';

export interface MapControlsProps {
  onZoomIn: () => void;
  onZoomOut: () => void;
  onMyLocation: () => void;
  isLocating?: boolean;
}

export const MapControls: React.FC<MapControlsProps> = ({
  onZoomIn,
  onZoomOut,
  onMyLocation,
  isLocating = false
}) => {
  return (
    <>
      {/* Zoom Controls */}
      <div className="absolute top-4 left-4 z-10 bg-white rounded-lg shadow-lg p-3">
        <div className="flex flex-col gap-1">
          <button
            onClick={onZoomIn}
            className="w-8 h-8 bg-white border border-gray-300 rounded flex items-center justify-center hover:bg-gray-50 transition-colors"
            title="تكبير"
            aria-label="تكبير"
          >
            <ZoomIn className="w-4 h-4 text-gray-600" />
          </button>
          <button
            onClick={onZoomOut}
            className="w-8 h-8 bg-white border border-gray-300 rounded flex items-center justify-center hover:bg-gray-50 transition-colors"
            title="تصغير"
            aria-label="تصغير"
          >
            <ZoomOut className="w-4 h-4 text-gray-600" />
          </button>
        </div>
      </div>

      {/* My Location Button */}
      <div className="absolute bottom-4 right-4 z-10">
        <button
          onClick={onMyLocation}
          disabled={isLocating}
          className={`
            bg-white text-sm font-medium border border-gray-300 rounded-full px-4 py-2 shadow-lg 
            hover:bg-gray-50 hover:shadow-xl transition-all duration-200 flex items-center gap-2
            ${isLocating ? 'opacity-50 cursor-not-allowed' : 'hover:scale-105'}
          `}
          title="تحديد موقعي الحالي"
          aria-label="تحديد موقعي الحالي"
        >
          {isLocating ? (
            <>
              <div className="w-4 h-4 border-2 border-brand-500 border-t-transparent rounded-full animate-spin"></div>
              <span>جاري التحديد...</span>
            </>
          ) : (
            <>
              <Navigation className="w-4 h-4 text-brand-600" />
              <span>📍 موقعي</span>
            </>
          )}
        </button>
      </div>
    </>
  );
};

export default MapControls;
